import { createElement } from 'react';
import { Drawer as OriginalDrawer } from 'antd';
const Drawer = (props) => {
    const innerProps = {};
    if (props.__designMode === 'design') {
        innerProps.open = true;
    }
    return createElement(OriginalDrawer, { ...props, ...innerProps });
};
export default Drawer;
